<template>
  <p class="fz-18 text-white font-medium">
    {{ text}}<br />
  </p>
</template>

<script>
export default {
  name: "textElement",
  props:['text']
}
</script>

<style scoped>

</style>